// extracted by mini-css-extract-plugin
export default {"box":"SocialUser_box__oqH72","socialBox":"SocialUser_socialBox__8Gm7F","socialText":"SocialUser_socialText__atuYk"};